module.exports = __webpack_public_path__ + "img/HelveticaNeueMediumGray.f2e6e40d.png";